// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1In3q","left":"styles_left__1lSGJ","desktopActions":"styles_desktopActions__14ZY6","title":"styles_title__16LZW"};